import Immutable from 'immutable';

import type FileInfoInk from 'sharedreact/data/FileInfoInk';

const Content: {
  id?: string,
  separationName: string | null,
  ruling: number,
  angle: number,
  dotShape: string | null,
  dotShapeDescription: string | null,
  dgc: string | null,
  percentage: number,
  separationInk: FileInfoInk | null
} = {
  id: undefined, // TODO FileInfoScreen should have an id that is set by the server
  separationName: null,
  ruling: -1,
  angle: -1,
  dotShape: null,
  dotShapeDescription: null,
  dgc: null,
  percentage: -1,
  separationInk: null
};

class FileInfoScreen extends Immutable.Record(Content) {
}

export default FileInfoScreen;
